var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9,
    width: 6,
    height: 5,
    stroke: "#C7A267"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 13,
    transform: "matrix(-1 0 0 1 13 1)",
    stroke: "#C7A267"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 6,
    height: 8,
    stroke: "#C7A267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/Ranking.a0249b27dc46222bec0fc1b1583dce98.svg";
export { ForwardRef as ReactComponent };